module.exports = __webpack_public_path__ + "static/media-a928c182a545abd8cd67a74080b9eff0.svg";